import { render } from "./edit-goods-list.vue?vue&type=template&id=6e16adbe&scoped=true&ts=true"
import script from "./edit-goods-list.vue?vue&type=script&lang=ts"
export * from "./edit-goods-list.vue?vue&type=script&lang=ts"

import "./edit-goods-list.vue?vue&type=style&index=0&id=6e16adbe&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e16adbe"]])

export default __exports__